import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
	getRebatesAndClaims,
	saveEditRebatesAssets,
	deleteAsset,
	saveRebatesAndClaims
} from '../../../../redux/actions';

class RebatesAndClaimForms extends Component {

	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
        }
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this,
			{ user: { userDetails } } = self.props.state;
		// redirect user to home page if he has not access to this page
		if(userDetails && !userDetails.isSiteManagementAccess) {
			browserHistory.push('/home');
		} else {
			self.props.getRebatesAndClaims('requestType=rebatesAndClaims');
		}
	}

	handleCreateRebateAsset(event) {
		event.preventDefault();
		browserHistory.push('/siteManagement/rebatesAndClaimForms/create');
	}

	handleEditRebateAsset(assetData, event) {
		event.preventDefault();
		const self = this;
		self.props.saveEditRebatesAssets(assetData);
		browserHistory.push('/siteManagement/rebatesAndClaimForms/edit');
	}

	handleDeleteRebateAsset(assetData, index, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			confirmationMessage: '',
			deletingAssetData: assetData
		}, () => {
			self.props.deleteAsset(assetData, 'requestType=rebatesAndClaims', response => {
				if(response.status && response.responseObject) {
					const { rebatesAndClaims } = JSON.parse(JSON.stringify(self.props.state.homepage));
					rebatesAndClaims.responseObject = rebatesAndClaims.responseObject.filter(item => item.docId !== self.state.deletingAssetData.docId);
					self.props.saveRebatesAndClaims(rebatesAndClaims);
					self.setState({
						confirmationMessage: 'Document has been successfully deleted.'
					});
				} else {
					browserHistory.push('/error');
				}
			});
		});
	}

    render() {
		const self = this;
		const { rebatesAndClaims } = self.props.state.homepage;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Rebates And Claim Forms</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				<div className="push">
					{rebatesAndClaims && rebatesAndClaims.responseObject &&
						<div>
							{this.state.confirmationMessage && <p className="bold red">{this.state.confirmationMessage}</p>}
							<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
					          	<thead>
						            <tr>
						              	<th className="brochureName">
						                	Name
						              	</th>
										<th className="brochureName">
						                	Group
						              	</th>
										<th className="editBrochure" style={{textAlign: 'center'}}>
						                	Edit
						              	</th>
										<th className="deleteBrochure" style={{textAlign: 'center'}}>
						                	Delete
						              	</th>
						            </tr>
					          	</thead>
					          	<tbody>
									{rebatesAndClaims.responseObject.length === 0
										?<tr>
											<td className="brochureName" colSpan={4}>
												No document found.
											</td>
										</tr>
										:null
									}
									{rebatesAndClaims.responseObject.map((item, index) => {
										return <tr key={index+1}>
							              	<td className="brochureName">
							                	{item.displayName}
							              	</td>
											<td className="brochureName">
							                	{item.docGroup}
							              	</td>
											<td className="editBrochure text-center">
							                	<a className="editBrochureIcon" href="" onClick={this.handleEditRebateAsset.bind(this, item)}>
													<img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Asset" title="Edit Asset" />
												</a>
							              	</td>
											<td className="deleteBrochure text-center">
												<a className="deleteBrochureLink" href="" onClick={this.handleDeleteRebateAsset.bind(this, item, index)}>✗</a>
											</td>
							            </tr>
									})}
					          	</tbody>
					        </table>
							<p className="textRight">
								<input type="button" onClick={this.handleCreateRebateAsset.bind(this)} className="blueButton uppercase" defaultValue="Create Asset" />
							</p>
						</div>
					}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getRebatesAndClaims: (queryStringParams, callback) => dispatch(getRebatesAndClaims(queryStringParams, callback)),
	deleteAsset: (payload, queryStringParams, callback) => dispatch(deleteAsset(payload, queryStringParams, callback)),
	saveEditRebatesAssets: (data) => dispatch(saveEditRebatesAssets(data)),
	saveRebatesAndClaims: (data) => dispatch(saveRebatesAndClaims(data)),
});

RebatesAndClaimForms = connect(mapStateToProps, mapDispatchToProps)(RebatesAndClaimForms);
export default RebatesAndClaimForms;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/RebatesAndClaimForms/index.js